/*
 * File: c:\Users\l.haddad\Desktop\mobybuy_backoffice\src\Content\Contact\AddressContact\AddressFormBasic\AddressFormBasic.tsx
 * Project: c:\Users\l.haddad\Desktop\mobybuy_backoffice
 * Created Date: Tuesday May 27th 2025
 * Author: Tommy Boisseau
 * -----
 * Last Modified: Tuesday May 27th 2025 2:59:16 pm
 * Modified By: the developer formerly known as Tommy Boisseau at <t.boisseau@autobuy.fr>
 * -----
 * Copyright (c) 2025 Autobuy SAS
 * -----
 */

import { forwardRef, useImperativeHandle, useState } from "react";
import { AddressContactProps } from "../AddressContactProps.type";
import translator from "MultiLanguage/TranslationWrapper";
import { TextField } from "@mui/material";
import Styles from "Content/Contact/AddressContact/AddressFormBasic/AdressFormBasic.module.css";

const AddressFormBasic = forwardRef((props: AddressContactProps, ref) =>  {
    const [address, setAddress] = useState<string>();
    const [city, setCity] = useState<string>();
    const [state, setState] = useState<string>();
    const [postalCode, setPostalCode] = useState<string>();
    const [country, setCountry] = useState<string>();

    useImperativeHandle(ref, () => {
      if (props.onUpdate)
        props.onUpdate();
      return {
        address,
        city,
        state,
        postalCode,
        country
      };
    }, [address, city, state, postalCode, country]);

    return (
        <div className={`${Styles.addressForm}`}>
            <TextField required size="small" className={`${Styles.formInput}`} value={address ?? ""} label={translator.decode("dynamic.address")} onChange={(e) => {setAddress(e.target.value)}}/>
            <div className={`${Styles.subAddress}`}>
                <TextField required size="small" className={`${Styles.formInput}`} value={postalCode ?? ""} label={translator.decode("dynamic.postalcode")} onChange={(e) => {setPostalCode(e.target.value)}}/>
                <TextField required size="small" className={`${Styles.formInput}`} value={city ?? ""} label={translator.decode("dynamic.city")} onChange={(e) => {setCity(e.target.value)}}/>
                <TextField required size="small" className={`${Styles.formInput}`} value={state ?? ""} label={translator.decode("dynamic.state")} onChange={(e) => {setState(e.target.value)}}/>
                <TextField required size="small" className={`${Styles.formInput}`} value={country ?? ""} label={translator.decode("dynamic.country")} onChange={(e) => {setCountry(e.target.value)}}/>
            </div>
        </div>
    );

});

export default AddressFormBasic;
